<template>
  <ap-dropdown :trigger="['click']" @open-change="openChangeHandler" placement="bottom">
    <div class="flex flex-col w-full cursor-pointer h-avatar-container p-4">
      <div
        :class="[
          'grid items-center gap-3 w-full text-black font-medium text-sm grid-cols-[24px_1fr] max-w-full h-8 rounded p-1',
          { 'bg-black/5': dropdownIsOpen }
        ]">
        <ap-avatar :src="user.avatar" class="h-6 w-6 flex justify-center items-center uppercase">
          {{ user.avatar.length == 1 ? user.avatar : user.userAvatarLetter }}
        </ap-avatar>
        <span
          class="max-w-full text-ellipsis whitespace-nowrap overflow-hidden text-sm font-medium text-black">
          {{ user.name }}
        </span>
      </div>
    </div>
    <template #overlay>
      <div class="user-avatar-dropdown">
        <ap-menu class="!p-0 user-avatar-dropdown">
          <div class="menu-user-details p-4">
            <ap-typography
              :key="key"
              v-for="(item, key) in [user.name, user.email]"
              :class="[
                'text-black font-semibold text-xs leading-normal max-w-full text-ellipsis whitespace-nowrap overflow-hidden',
                { 'text-black/60': key != 0 }
              ]">
              {{ item }}
            </ap-typography>
          </div>
          <hr class="m-0 border border-solid border-black/5" />
          <div class="menu-items-wrapper py-4 px-2">
            <ap-menu-item
              class="menu-item !h-8 text-black text-xs font-normal hover:bg-primary/5 hover:text-primary hover:font-semibold px-2"
              :key="key"
              v-for="(item, key) in accountOptions"
              @click="item.onClick"
              title="">
              <template #icon>
                <component :is="item.icon" class="text-[16px]" />
              </template>
              {{ item.text }}
            </ap-menu-item>
          </div>
        </ap-menu>
      </div>
    </template>
  </ap-dropdown>
</template>

<script setup>
import { computed, ref } from "vue"
import { useI18n } from "vue-i18n"
import { useRouter } from "vue-router"
import { useUserStore } from "@/stores/user"
import { useUserAccountsStore } from "../../stores/userAccounts"
import { LogoutOutlined, UserOutlined } from "@ant-design/icons-vue"
import { useAuthentication } from "@/composables/useAuthentication"

const { t } = useI18n()
const router = useRouter()
const userStore = useUserStore()
const userAccountsStore = useUserAccountsStore()
const dropdownIsOpen = ref(false)

const user = computed(() => ({
  name: userStore.user?.name || "",
  email: userStore.user?.email || "",
  avatar: userStore.userAvatar?.length
    ? userStore.userAvatar
    : userStore.userAvatarLetter?.length
      ? userStore.userAvatarLetter
      : "",
  userAvatarLetter: userStore.userAvatarLetter,
  workspaceName: userAccountsStore.userAccountDetail?.accountName,
  workspaceLogo: userAccountsStore.userAccountDetail?.logo
}))

function handleAccount() {
  router.push({ name: "account" })
}
async function handleLogout() {
  useAuthentication().logout()
  router.push({ name: "login" })
}

const accountOptions = computed(() => {
  return [
    { text: t("navigation.account.label"), icon: UserOutlined, onClick: handleAccount },
    { text: t("navigation.logout.label"), icon: LogoutOutlined, onClick: handleLogout }
  ]
})

function openChangeHandler(newValue) {
  dropdownIsOpen.value = newValue
}
</script>

<style lang="postcss">
.user-avatar-dropdown ul {
  @apply !min-w-[228px] !w-[228px] !max-w-[228px] !left-4 bg-white !rounded-xl !p-0;

  li:not(:hover) {
    .anticon {
      @apply text-black/60;
    }
  }
}

.ant-avatar .ant-avatar-string {
  @apply max-h-6 max-w-6 flex items-center justify-center;
}
</style>
